import { Box } from '@mui/material';
import UPInput from 'components/input';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CONTRACTS__BREAK,
  CONTRACTS__END_WORK,
  CONTRACTS__NO_REGISTRATION_EXISTS,
  CONTRACTS__REGISTERED_TIME,
  CONTRACTS__START_WORK,
} from 'translations/constants';
import { ReactComponent as ClockIcon } from '../../../assets/icons/ClockIcon.svg';
import {
  BreakDivider,
  BreakTitle,
  ColumnTitleRow,
  EmptyStateText,
  OrangeBorderWrapper,
  SubSectionTitle,
  TimeColumnContainer,
  TimeFieldsRow,
  TimeFieldWrapperSmall,
} from '../styles';
import { BreakRegistration } from '../types';

interface RegisteredTimeColumnProps {
  hasRegistration: boolean;
  startTime: string | null;
  endTime: string | null;
  breaks: BreakRegistration[];
  isStartTimeAdjusted: boolean;
  isEndTimeAdjusted: boolean;
}

const RegisteredTimeColumn = (props: RegisteredTimeColumnProps) => {
  const { hasRegistration, startTime, endTime, breaks, isStartTimeAdjusted, isEndTimeAdjusted } = props;
  const { t } = useTranslation();

  const wrapWithOrangeBorder = (element: ReactNode, isAdjusted: boolean) => {
    if (!isAdjusted) return element;
    return <OrangeBorderWrapper>{element}</OrangeBorderWrapper>;
  };

  return (
    <TimeColumnContainer>
      <ColumnTitleRow>
        <ClockIcon fill="#303C42" />
        <SubSectionTitle>{t(CONTRACTS__REGISTERED_TIME)}</SubSectionTitle>
      </ColumnTitleRow>
      {!hasRegistration ? (
        <EmptyStateText>{t(CONTRACTS__NO_REGISTRATION_EXISTS)}</EmptyStateText>
      ) : (
        <>
          <TimeFieldsRow>
            <TimeFieldWrapperSmall>
              {wrapWithOrangeBorder(
                <UPInput
                  value={startTime ?? ''}
                  onChange={null}
                  placeholder=""
                  label={t(CONTRACTS__START_WORK)}
                  disabled
                  id="detail-panel-registered-start"
                />,
                isStartTimeAdjusted,
              )}
            </TimeFieldWrapperSmall>
            <TimeFieldWrapperSmall>
              {wrapWithOrangeBorder(
                <UPInput
                  value={endTime ?? ''}
                  onChange={null}
                  placeholder=""
                  label={t(CONTRACTS__END_WORK)}
                  disabled
                  id="detail-panel-registered-end"
                />,
                isEndTimeAdjusted,
              )}
            </TimeFieldWrapperSmall>
          </TimeFieldsRow>
          {breaks.map((breakItem, index) => (
            <Box key={`registered-break-${index.toString()}`}>
              <BreakDivider />
              <Box height={8} />
              <BreakTitle>{`${t(CONTRACTS__BREAK)} ${index + 1}`}</BreakTitle>
              <TimeFieldsRow>
                <TimeFieldWrapperSmall>
                  <UPInput
                    value={breakItem.startTime}
                    onChange={null}
                    placeholder=""
                    label={t(CONTRACTS__START_WORK)}
                    disabled
                    id={`detail-panel-registered-break-${index.toString()}-start`}
                  />
                </TimeFieldWrapperSmall>
                <TimeFieldWrapperSmall>
                  <UPInput
                    value={breakItem.endTime}
                    onChange={null}
                    placeholder=""
                    label={t(CONTRACTS__END_WORK)}
                    disabled
                    id={`detail-panel-registered-break-${index.toString()}-end`}
                  />
                </TimeFieldWrapperSmall>
              </TimeFieldsRow>
            </Box>
          ))}
        </>
      )}
    </TimeColumnContainer>
  );
};

export default RegisteredTimeColumn;
